import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../styles';

const useStyles = createUseStyles(
  {
    root: {
      marginBottom: 80,
    },
    heading: {
      fontSize: '24px',
      lineHeight: '32px',
      color: 'var(--x-accent-2-1)',
      fontWeight: 700,
      marginBottom: 12,
    },
    question: {
      listStylePosition: 'inside',
      '&:hover': {
        cursor: 'pointer',
      },
      fontSize: '16px',
      lineHeight: '28px',
      color: 'var(--x-accent-2-1)',
      fontWeight: FontWeight.Medium,
      textDecoration: 'underline',
    },
  },
  {
    name: 'table-of-contents',
  },
);

export default useStyles;
